import { Injectable, inject } from '@angular/core';
import { Router, type NavigationBehaviorOptions } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { map, take, withLatestFrom } from 'rxjs/operators';

import AppActions from '@web/store/app/app.actions';
import SiteActions from '@web/store/website/site/site.actions';
import PagesActions from '@web/store/website/pages/pages.actions';
import { AppFacade } from '@web/store/app/app.facade';

@Injectable()
export class RouterEffects {
    private readonly actions$ = inject(Actions);
    private readonly router = inject(Router);
    private readonly appFacade: AppFacade = inject(AppFacade);

    // INIT APP WHEN ROUTER IF NAVIGATED FIRST TIME
    private readonly routerInit$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ROUTER_NAVIGATED),
            take(1),
            map(() => AppActions.initApp())
        )
    );

    private readonly navigateSitePage$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PagesActions.navigateSitePage),
                withLatestFrom(
                    this.appFacade.isEcommerceModeShallow$,
                    ({ siteId, pageId }, isEcommerceModeShallow) => ({
                        siteId,
                        pageId,
                        isEcommerceModeShallow,
                    })
                ),
                map(({ siteId, pageId, isEcommerceModeShallow }) => {
                    const params: Partial<NavigationBehaviorOptions> = { replaceUrl: true };
                    if (isEcommerceModeShallow) {
                        params.replaceUrl = false;
                        params.skipLocationChange = true;
                    }

                    this.router.navigate([`/${siteId}/page/${pageId}`], params);
                })
            ),
        { dispatch: false }
    );

    private readonly navigateTemplateSitePage$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SiteActions.navigateTemplateSitePage),
                map(({ templateId, siteId, pageId }) => {
                    this.router.navigate([`/${siteId}/page/${pageId}`], {
                        queryParams: { templateId },
                        replaceUrl: true,
                    });
                })
            ),
        { dispatch: false }
    );
}
